import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { normalizeRemoteLanguage, remoteText } from './remoteI18n';

const statusLabels = {
    idle: 'statusIdle', preparing: 'statusPreparing', waiting: 'statusWaiting',
    connecting: 'statusConnecting', connected: 'statusConnected', error: 'statusIdle',
};

export default function RemoteConnectionPanel({ connection, lang = 'en' }) {
    const { status, link, messageKey, connect, disconnect } = connection;
    const t = key => remoteText(lang, key);
    const [copyMessage, setCopyMessage] = useState('');
    useEffect(() => setCopyMessage(''), [link]);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopyMessage('copySuccess');
        } catch {
            setCopyMessage('copyManual');
        }
    };

    return (
        <section className='remotePanel' aria-label={t('title')} lang={normalizeRemoteLanguage(lang)}>
            <div className='remotePanelHeading'>
                <div>
                    <h2>{t('title')}</h2>
                    <p>{t('description')}</p>
                </div>
                <span className={`remoteStatus remoteStatus-${status}`} role='status'>{t(statusLabels[status])}</span>
            </div>
            <div className='remoteActions'>
                <button type='button' className='btn btn-primary' disabled={status === 'preparing'} onClick={connect}>
                    {t(status === 'idle' || status === 'error' ? 'connect' : 'newLink')}
                </button>
                {!['idle', 'error'].includes(status) && (
                    <button type='button' className='btn btn-outline-secondary' onClick={disconnect}>{t('disconnect')}</button>
                )}
            </div>
            {link && (
                <div className='remotePairing'>
                    <figure className='remotePairingQR'>
                        <QRCodeSVG
                            value={link} size={256} level='M' marginSize={4}
                            bgColor='#ffffff' fgColor='#000000'
                            role='img' aria-label={t('qrLabel')}
                        />
                        <figcaption>{t('qrCaption')}</figcaption>
                    </figure>
                    <div className='remotePairingDetails'>
                        <p>{t('qrInstructions')}</p>
                        <p>{t('qrExpiry')}</p>
                        <label htmlFor='remote-viewing-link'>{t('linkLabel')}</label>
                        <div className='remoteLinkRow'>
                            <input id='remote-viewing-link' type='text' value={link} readOnly onFocus={event => event.target.select()} />
                            <button type='button' className='btn btn-outline-primary' onClick={copy}>{t('copyLink')}</button>
                        </div>
                        {copyMessage && <p role='status'>{t(copyMessage)}</p>}
                    </div>
                </div>
            )}
            {messageKey && <p className={status === 'error' ? 'remoteError' : ''} role='status'>{t(messageKey)}</p>}
            {status === 'connected' && <p className='remoteConnectionMethod'>{t(connection.transport === 'http' ? 'connectionServer' : 'connectionDirect')}</p>}
        </section>
    );
}
